import { render, staticRenderFns } from "./studentLunwenDetail-page.html?vue&type=template&id=71ad3c71&"
import script from "./studentLunwenDetail-page.ts?vue&type=script&lang=ts&"
export * from "./studentLunwenDetail-page.ts?vue&type=script&lang=ts&"
import style0 from "./studentLunwenDetail-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports